module.exports = __webpack_public_path__ + "static/media/review_3.357c680a.png";